import { render, staticRenderFns } from "./handoverDialog.vue?vue&type=template&id=9d33a1f8&scoped=true&"
import script from "./handoverDialog.vue?vue&type=script&lang=js&"
export * from "./handoverDialog.vue?vue&type=script&lang=js&"
import style0 from "./handoverDialog.vue?vue&type=style&index=0&id=9d33a1f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d33a1f8",
  null
  
)

export default component.exports